import { OverviewWebinarsPage } from '@online-webinar/public';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/'].update({
        staticData: { title: { page: 'Schedule.PageHeading' } },
        component: OverviewWebinarsPage
    });
};
